import React, { MouseEvent } from 'react'
import styled from 'styled-components/macro'

export type Props = {
  symbolImg?: string
  name: string
  value: string | number
  balance?: string
  onClick?: (e: MouseEvent) => void
}

export default function SymbolCard({ symbolImg, name, value, onClick, balance }: Props) {
  return (
    <SymbolContainer onClick={onClick}>
      <a>
        <SymbolImg alt="symbolImg" src={symbolImg} />
        <SymbolName>
          {name} ({value})
        </SymbolName>
        {balance && (
          <SymbolBalance>
            Balance {balance} {value}
          </SymbolBalance>
        )}
      </a>
    </SymbolContainer>
  )
}

const SymbolContainer = styled.div`
  border: 1px solid #d7d7d8;
  border-radius: 4px;
  text-align: center;
  align-items: center;
  flex-basis: 20%;
  margin: 10px;
  padding: 20px 10px;
  cursor: pointer;
  &:hover {
    border: 1px solid #d7d7d8;
    box-shadow: 0 3px 6px #ccc;
    border-radius: 4px;
    text-align: center;
    align-items: center;
    flex-basis: 20%;
    margin: 10px;
    padding: 20px 10px;
  }
`

const SymbolImg = styled.img`
  margin-bottom: 20px;
  width: 65px;
  height: 65px;
`

const SymbolName = styled.h5`
  font-size: 16px;
  padding-top: 10px;
`

const SymbolBalance = styled.p`
  font-size: 12px;
  padding-top: 10px;
`
